export default "__VITE_ASSET__DpA_5m10__"